<template>
  <div class="parts">
    <!-- parts card -->
    <draggable
      :group="{ name: 'contentParts', pull: 'clone', put: false }"
      :clone="cloneParts"
      :list="editParts"
      @start="startCloneParts"
      @end="onMovedParts"
      :sort="false"
    >
      <div v-for="editPart in editParts" :key="editPart.id" class="parts-card">
        <div class="parts-card-image">
          <img
            :src="editPart.image"
            :class="{'share-button': editPart.type === 'Share'}"
          >
        </div>
        <div
          class="parts-card-text ghost-text"
          :class="{'boxed-text': editPart.type === 'BoxedText', 'image-text': editPart.type === 'ImageText'}"
        >
          {{ editPart.displayName }}
        </div>
      </div>
    </draggable>
  </div>
</template>

<script>
import Draggable from 'vuedraggable'

export default {
  name: 'content-parts',
  components: {
    Draggable,
  },
  data () {
    return {
      isDeveloper: false, // ロゴパーツを表示するサイトか
      editParts: [],
      defaultParts: {},
    }
  },
  created () {
    this.$http({
      type: 'GET',
      url: '/content/parts_containers',
    }).then(json => {
      if (json && json.status === 200) {
        this.isDeveloper = json.data.isDeveloper
        delete json.data.isDeveloper
        this.defaultParts = Object.fromEntries(
          Object.entries(json.data).map(parts => {
            // 画像がなかったら差し替える
            if (!parts[1].image) {
              parts[1].image = '../../../../../static/loading.png'
            }
            this.editParts.push({
              'id': parts[1].id,
              'type': parts[1].type,
              'displayName': parts[1].display_name,
              'image': parts[1].image,
            })
            return parts
          })
        )
      }
    })
  },
  methods: {
    // 部品複製移動時の処理：section_idとorder_idは、PreviewSectionのonChangeで後でセットする
    cloneParts (event) {
      // 存在しないパーツが追加されたら、エラー
      if (!(event.type in this.defaultParts)) {
        this.$store.commit('showErrorMessagePopup', ['作成中'])
        return
      }
      // deep copy
      const partsContainer = JSON.parse(JSON.stringify(this.defaultParts[event.type]))

      // パーツコンテナのIDをセット
      partsContainer.id = this.$store.getters.partsContainersMaxId + 1

      // パーツのIDをセット
      let partId = this.$store.getters.partsMaxId + 1
      partsContainer.parts.map(part => {
        part.id = partId
        partId++
      })
      return partsContainer
    },
    onMovedParts () {
      this.$store.commit('toggleDragPartsContainerAssist', { showState: false })
    },
    startCloneParts () {
      this.$store.commit('toggleDragPartsContainerAssist', { showState: true })
    },
  }
}
</script>

<style lang="scss" scoped>
.parts {
  color: $commonFontColor;
  overflow-y: auto;
  height: calc(100vh - 145px);
  >div {
    display: flex;
    flex-wrap: wrap;
    padding-top: 20px;
    width: 388px;
    margin: 0 auto;
  }
  .parts-card {
    width: 104px;
    height: 110px;
    border: 0.5px solid#dbdbdb;
    margin: 0 30px 30px 0;
    border-radius: 2px;
    overflow: hidden;
    box-shadow: 0 3px 4px rgba(198, 198, 198, 0.5);
    transition: all 0.1s ease;
    cursor: pointer;
    &:hover {
      transform: scale(1.05);
      box-shadow: 0 13px 13px rgba(198, 198, 198, 0.6);
    }
    &:nth-of-type(3n) {
      margin: 0;
    }
    .boxed-text {
      letter-spacing: -2px;
    }
    .image-text {
      letter-spacing: -0.8px;
    }
    .parts-card-image {
      height: calc( 110px - 40px );
      background: rgba(#9E9E9E, 0.7);
      display: flex;
      justify-content: center;
      align-items: center;
      .share-button {
        padding-right: 5px;
      }
      img {
        max-width: 70%;
        max-height: 70%;
        height: auto;
      }
    }
    .parts-card-text {
      height: 40px;
      line-height: 40px;
      font-size: 13px;
      background: #fff;
      font-weight: bold;
      text-align: center;
    }
  }
}
</style>
